import SurflineLogo from './SurflineLogo';

export default SurflineLogo;
